import React, { useEffect, useState } from "react";
import { checkUserHasAccountRole } from "app/services/app.state.service";
import { Grid } from "@mui/material";
import { handleAxiosError } from "app/services/app.error.handler";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "store/member-slice";
import { loadMembersForAllClientsFromBackend } from "app/services/member.service";
import EffortSummaryView from "../effortSummary/EffortSummaryView";
import ExportReportsView from "../export-reports/ExportReportsView";

export const AccountDashboard = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const members = useSelector((state) => state.member.rows);

 
  useEffect(() => {
    if (!checkUserHasAccountRole()) {
      return <div>You do not have access to this functionality.</div>;
    }

    if (members.length === 0) {
      loadMembersForAllClientsFromBackend()
        .then((response) =>
          dispatch(memberActions.replaceData(response?.data))
        )
        .catch((error) => {
          dispatch(memberActions.replaceData([])); // Set the empty data in activity table
          handleAxiosError(error);
        });
    }
  }, [dispatch, members.length]);

  if (!checkUserHasAccountRole()) {
    return <div>You do not have access to this functionality.</div>;
  }

  if (isLoading) {
    return <div>Loading Account dashboard...</div>;
  }

  return (
    <div className="content-container" style={{ width: "100%" }}>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={12}>
          <EffortSummaryView />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <ExportReportsView />
        </Grid>
      </Grid>
    </div>
  );
};
